<template>
  <div class="modal-card" style="width: 30cm">
    <header class="modal-card-head">
      <p v-if="story == true" class="modal-card-title">Verdiepingen Aanmaken</p>
      <p v-else class="modal-card-title">Verdiepingen Aanmaken</p>
    </header>
    <section class="modal-card-body">
      <div v-if="story">
        <naming-table v-if="story == true" v-bind:data="data" type="Verdieping"></naming-table>
        <h4 class="title is-4">Wilt u voor alle verdiepingen ook zones toevoegen?</h4>
        <h6 class="subtitle is-6">Dit kunt u later ook nog per zone doen</h6>
        <div class="field" v-if="story == true">
          <b-radio v-model="radio" native-value="zones" type="is-success">Ja</b-radio>
          <b-radio v-model="radio" native-value="negative" type="is-danger">Nee</b-radio>
        </div>
      </div>
      <naming-table v-bind:data="data2" type="Zone" v-if="radio == 'zones' || story != true"></naming-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
      <button class="button is-primary" @click="createStory" :disabled="radio == 'default' && story == true">
        Maak aan
      </button>
    </footer>
  </div>
</template>
<script>
import ProjectService from '@/services/projectService'
import NamingTable from '@/components/Projects/NamingTable'
import { mapGetters } from 'vuex'

export default {
  components: { NamingTable },
  props: ['projectId', 'buildingId', 'story'],
  data() {
    return {
      radio: 'default',
      data: [{ order: 1, norder: 1, name: 'Voorbeeld Verdieping 1' }],
      data2: [{ order: 1, norder: 1, name: 'Voorbeeld Zone 1' }]
    }
  },
  computed: {
    ...mapGetters(['selectedFloor'])
  },
  methods: {
    async createStory() {
      if (this.story) {
        for (let i = 1; i <= this.data.length; i++) {
          const index = this.data.findIndex(o => o.order === i)
          const payload = {
            projectId: this.projectId,
            buildingId: this.buildingId,

            name: this.data[index].name
          }
          const responseStory = await ProjectService.assignStoryToBuilding(payload)
          if (responseStory.status == 200) {
            const storyId = responseStory.data

            if (this.radio == 'zones') {
              for (let k = 1; k <= this.data2.length; k++) {
                const indexZone = this.data2.findIndex(o => o.order === k)
                const responseZone = await ProjectService.assignZoneToStory({
                  projectId: this.projectId,
                  storyId: storyId,
                  name: this.data2[indexZone].name
                })
              }

              this.$store.getters.selectedBuilding.stories.push({
                storyId: storyId, //storyId.toString(),
                buildingId: this.buildingId,
                zones: new Array(this.data2.lenght),
                openingCount: 0
              })
            } else {
              this.$store.getters.selectedBuilding.stories.push({
                storyId: storyId, //storyId.toString(),
                buildingId: this.buildingId,
                zones: [],
                openingCount: 0
              })
            }
          }
        }
      } else {
        const storyId = this.selectedFloor.storyId

        for (let k = 1; k <= this.data2.length; k++) {
          const indexZone = this.data2.findIndex(o => o.order === k)
          const responseZone = await ProjectService.assignZoneToStory({
            projectId: this.projectId,
            storyId: storyId,
            name: this.data2[indexZone].name
          })
          if (responseZone.status == 200) {
            this.$store.getters.selectedFloor.zones.push({
              zoneId: responseZone.data.toString(),
              storyId: storyId,
              name: this.data2[indexZone].name
            })
          }
        }
      }
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/StoryModal.vue